export default {
  icon: require('./images/icon.png'),
  fullLogo: require('./images/fullLogo.png'),
}
